import React from 'react';
import PrivacyPolicy from '../components/PrivacyPolicy/PrivacyPolicy';
import '../assets/css/privacy_policy.css';

const PrivacyPolicyPage = () => {

  return (
    <div>
      <PrivacyPolicy />
    </div>
  );
};

export default PrivacyPolicyPage;


/** WEBPACK FOOTER **
 ** ./src/containers/PrivacyPolicyPage.js
 **/